import Enum from '@/modules/core/app/helpers/Enum';

export class ReadReceiptActionType extends Enum {
  key!: string;

  static CREATED: ReadReceiptActionType = { key: 'created' };
  static UPDATED: ReadReceiptActionType = { key: 'updated' };
}
